import { render, staticRenderFns } from "./userContactHistory.vue?vue&type=template&id=5a9385c0&scoped=true"
import script from "./userContactHistory.vue?vue&type=script&lang=js"
export * from "./userContactHistory.vue?vue&type=script&lang=js"
import style0 from "./userContactHistory.vue?vue&type=style&index=0&id=5a9385c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9385c0",
  null
  
)

export default component.exports